import wx from 'weixin-js-sdk'
import axios from '../http'

import Config from '../config/config'

export const SDKRegister = (webUrl, jsApiList = [], callback) => {
  // 获取微信JSSDK配置
  var url = 'http://guohuaci-admin.qumahudong.com/system/jssdk/signature/'
  var data = {}
  // alert(webUrl)
  var params = {
    'url': encodeURIComponent(webUrl)
  }
  if (!jsApiList.length) {
    jsApiList = [
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
      'getLocation',
      'scanQRCode',
      'openLocation'
    ]
  }
  axios.get(url + '?url=' + params.url).then(res => {
    console.log(res.data)
    data = res.data.data
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: Config.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: jsApiList
    })
  })

  wx.ready((res) => {
    // 如果需要定制ready回调方法
    return callback(null)
  })
}




// WEBPACK FOOTER //
// ./src/util/weixin.js